<form [formGroup]="expenseDetailsForm" (ngSubmit)="onSubmit()">
  <input type="hidden" formControlName="campaignId" />
  <input type="hidden" formControlName="expenseRequestId" />
  <input type="hidden" formControlName="isEntity" />
  <p-card>
    <div class="formgrid grid">
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="vendor" class="field-label required">
          Vendor
        </label>
        <p-autoComplete id="vendor" formControlName="vendor" [suggestions]="vendorSuggestions"
          (completeMethod)="searchVendor($event.query)" (onSelect)="onVendorSelect($event)"
          placeholder="Type to Search"></p-autoComplete>
        <div>
          <small *ngIf="expenseDetailsForm.get('vendor')?.invalid && expenseDetailsForm.get('vendor')?.touched"
            class="p-error">Vendor is required.</small>
        </div>
        <div class="mt-4">
          <p-button label="Edit Vendor Information" (onClick)="showVendorModal()" [disabled]="!vendorSelected" [text]="true" size="small" severity="secondary">
          </p-button>
        </div>
      </div>
      <div *ngIf="isEntity" class="col-12 sm:col-6 xl:col-3">
        <!-- Campaign -->
        <div class="field">
          <label for="childCampaignId" class="field-label required">Campaign</label>
          <p-dropdown inputId="childCampaignId" [options]="childCampaigns" formControlName="childCampaignId"
            optionLabel="value" optionValue="key" placeholder="Please Select" [showClear]="true"
            filter="true"></p-dropdown>
          <small
            *ngIf="expenseDetailsForm.get('childCampaignId')?.invalid && expenseDetailsForm.get('childCampaignId')?.touched"
            class="error">
            Campaign is required.
          </small>
        </div>

        <!-- Fund Code -->
        <div class="field mt-3">
          <label for="fundCodeId" class="field-label required">Fund Code</label>
          <p-dropdown inputId="fundCodeId" [options]="fundcodes" formControlName="fundCodeId" optionLabel="value"
            optionValue="key" placeholder="Please Select" [showClear]="true" filter="true"></p-dropdown>
          <small *ngIf="expenseDetailsForm.get('fundCodeId')?.invalid && expenseDetailsForm.get('fundCodeId')?.touched"
            class="error">
            Please select a fund code.
          </small>
        </div>
      </div>
      <div *ngIf="!isEntity" class="field col-12 sm:col-6 xl:col-3">
        <label for="fundCodeId" class="field-label required">
          Fund Code
        </label>
        <p-dropdown inputId="fundCodeId" [options]="fundcodes" formControlName="fundCodeId" optionLabel="value"
          optionValue="key" placeholder="Please Select" [showClear]="true" filter="true">
        </p-dropdown>
        <small *ngIf="expenseDetailsForm.get('fundCodeId')?.invalid && expenseDetailsForm.get('fundCodeId')?.touched"
          class="error">
          Please select a fund code.
        </small>
      </div>
      <div class="field col-12 sm:col-6 xl:col-6">
        <label for="description" class="field-label">Description</label>
        <textarea id="description" formControlName="description" rows="4" cols="50" pInputTextarea
          style="resize: none;"></textarea>
      </div>
    </div>
  </p-card>

  <p-card>
    <div class="formgrid grid">
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="dueDate" class="field-label required">
          Due Date
        </label>
        <p-calendar id="dueDate" formControlName="dueDate" [showIcon]="true" [iconDisplay]="'input'"
          dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY"></p-calendar>
        <small *ngIf="expenseDetailsForm.get('dueDate')?.invalid && expenseDetailsForm.get('dueDate')?.touched"
          class="error">
          Date is required.
        </small>
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="requestedAmount" class="field-label required">Requested Amount</label>
        <input
          id="requestedAmount"
          pInputText
          formControlName="requestedAmount"
          type="text"
          class="form-control"
          (input)="onAmountInput($event)"
          placeholder="Enter requested amount"
        />
        <small
          *ngIf="expenseDetailsForm.get('requestedAmount')?.invalid && expenseDetailsForm.get('requestedAmount')?.touched"
          class="error">
          Amount is required.
        </small>
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="calculatedamount" class="field-label">Calculated Amount</label>
        <input id="calculatedamount" formControlName="calculatedamount" type="number" placeholder="$" pInputText />
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="paymentMethodId" class="field-label required">
          Payment Method
        </label>
        <p-dropdown inputId="paymentMethodId" [options]="paymentmethods" formControlName="paymentMethodId"
          optionLabel="value" optionValue="key" placeholder="Select a Payment" [showClear]="true" filter="true">
        </p-dropdown>
        <small
          *ngIf="expenseDetailsForm.get('paymentMethodId')?.invalid && expenseDetailsForm.get('paymentMethodId')?.touched"
          class="error">
          Payment Method is required.
        </small>
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="invoiceDate" class="field-label">
          Invoice / Accrual Date
        </label>
        <p-calendar id="invoiceDate" formControlName="invoiceDate" [showIcon]="true" [iconDisplay]="'input'"
          dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY"></p-calendar>
        <small *ngIf="expenseDetailsForm.get('invoiceDate')?.invalid && expenseDetailsForm.get('invoiceDate')?.touched"
          class="error">
          Date is required.
        </small>
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="invoicenumber" class="field-label">Invoice Number</label>
        <input id="invoicenumber" formControlName="invoicenumber" type="text" pInputText />
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="checkBookId" class="field-label required">
          Checkbook
        </label>
        <p-dropdown inputId="checkBookId" [options]="checkbookItems" formControlName="checkBookId" optionLabel="value"
          optionValue="key" placeholder="Please Select" [showClear]="true" filter="true">
        </p-dropdown>
        <small *ngIf="expenseDetailsForm.get('checkBookId')?.invalid && expenseDetailsForm.get('checkBookId')?.touched"
          class="error">
          Checkbook is required.
        </small>
      </div>
    </div>
  </p-card>

  <p-card>
    <div class="formgrid grid">
      <div class="field col-12 sm:col-6 xl:col-3">
        <label class="field-label">Payment Status</label>
        <p-tag [severity]="getSeverityAndValue(expenseStatus).severity" [value]="getSeverityAndValue(expenseStatus).value"
          [ngClass]="'block pt-1'">
        </p-tag>
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label class="field-label">Check Date</label>
        <i>Not Available</i>
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label class="field-label">Check Number</label>
        <i>Not Available</i>
      </div>
      <div class="field col-12 sm:col-6 xl:col-3">
        <label for="hold" class="field-label">Hold</label>
        <p-toggleButton inputId="hold" formControlName="hold" onLabel="Enabled" offLabel="Disabled" [onIcon]="onIcon"
          offIcon="pi pi-ban" styleClass="w-8rem"></p-toggleButton>
      </div>
    </div>
  </p-card>

  <p-card>
    <p-button type="submit" label="Next" severity="secondary"/>
  </p-card>
</form>

<!-- Add/Edit Vendor MODAL -->

<!-- header="{{ mode === 'add' ? 'Add New Vendor' : 'Update Vendor' }}" -->
<p-dialog [(visible)]="isShowVendor" 
  modal="true" 
  [maximizable]="true"
  [header]="selectedVendorId && selectedVendorId.length > 0 ? 'Edit Existing Vendor' : 'Add New Vendor'"
  styleClass="p-dialog-static p-dialog-lg fadeinright animation-duration-300" 
  (onHide)="closeVendor()">
  
  <ng-container *ngIf="isShowVendor">
    <vendor-add-update 
      [mode]="vendorMode"
      [vendorId]="selectedVendorId"
      [campaignId]="campaignId"
      [childCampaignId]="childCampaignId"
    (vendorAddedUpdated)="onVendorAddedUpdated($event)" (closeDialog)="closeVendor()"></vendor-add-update>
  </ng-container>
</p-dialog>
